<style src='animate.css/animate.css'></style>

<template>
  <div id='app' class='app-wrapper'>
    <div class='app-wrapper-inner'>
      <Header />
      <router-view></router-view>
      <Footer />
    </div>
  </div>
</template>

<script>
  import Header from './components/extended/Header.vue'
  import Footer from './components/extended/Footer.vue'

  export default {
    name: 'app',
    components: {
      Header,
      Footer
    },
  mounted() {
    this.$store.getters.ws.setStore(this.$store);
    this.$store.getters.ws.setRouter(this.$router);
    this.$store.dispatch("initChat");

    this.$store.getters.ws.socketPromise.then(socket => {
        window.console.log("Got socket:", socket);
      })

    }
  }
</script>